import { BaseItem } from '../common';
import { Ehr } from '../rpaJob';

export enum Kind {
  Ehr = 'EHR',
  Gateway = 'GATEWAY',
}

export enum UserPool {
  Human = 'HUMAN',
  Bot = 'BOT',
  Maintenance = 'MAINTENANCE',
}

export enum PasswordRotationState {
  PendingRotation = 'PENDING_ROTATION',
  RotationInProgress = 'ROTATION_IN_PROGRESS',
}

interface BaseCredential {
  credentialGroupId: string | null;
  ehrInstanceId: string | null;
  gatewayCredentialId: string | null;
  gcsmPasswordReferenceId: string;
  kind: Kind;
  phoneNumber: string | null;
  providerUserId: string | null;
  username: string;
  gcsm2faSecretReferenceId: string | null;
  userPool: UserPool;
  hostnames: string[] | null;
  lastRotated: Date | null;
  passwordRotationState: PasswordRotationState | null;
  maxSessions: number;
  otpInterval: number | null;
}

export interface Credential extends BaseItem, BaseCredential {}

export interface CreateValues
  extends Partial<
    Omit<BaseCredential, 'gcsmPasswordReferenceId' | 'gcsm2faSecretReferenceId'>
  > {
  password: string;
  twoFactorSecret?: string | null;
}

export interface UpdateValues
  extends Partial<
    Omit<BaseCredential, 'gcsmPasswordReferenceId' | 'gcsm2faSecretReferenceId'>
  > {}

export interface EhrCredentialV2 {
  departmentReferenceValues: string[] | null;
  ehrLoginUrl: string | null;
  gatewayAppName: string | null;
  gatewayEmbeddedUrl: string | null;
  gatewayKind: string | null;
  gatewayLoginUrl: string | null;
  gatewaySsoUrl: string | null;
  instance: string | null;
  kind: Ehr;
  mrnKind: string | null;
  vpnBaseUrl: string | null;
  vpnLoginUrl: string | null;
  ehrCredentialId: string;
  ehrUsername: string;
  ehrPassword: string;
  ehrPhoneNumber: string | null;
  gatewayCredentialId: string | null;
  gatewayUsername: string | null;
  gatewayPassword: string | null;
  gatewayPhoneNumber: string | null;
  userPool: UserPool;
  passwordRotationState: PasswordRotationState | null;
  providerUserId: string | null;
  hostname: string | null;
}
